// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"44":"8081f699","72":"681e48ea","318":"3a305e53","367":"2be6bdbf","398":"94b9a301","405":"9da240c5","453":"a75b7950","493":"b9bdbae8","593":"9b47a68d","869":"208fc34a","881":"068dcc22"}[chunkId] + ".chunk.js";
};